/**
 * Super-admin (platform) navigation prefix.
 *
 * Composed in Layout.tsx as: [platformGroup, ...adminGroups]. Pages are
 * shared with tenant-admin; the Platform group adds the cross-tenant
 * surfaces only super-admins can reach. A tenant filter (rendered in the
 * sidebar `topSlot`) scopes which tenant's data the shared pages display.
 *
 * Platform pages live under `pages/platform/...` per the convention in
 * docs/FeatureDesigns/multi-tenancy/multi-tenancy-rollout-plan.md §T1.
 */

import type { NavItem } from '@shared-ui/sidebar';

export const platformNavGroup: NavItem = {
    label: 'Platform',
    icon: '\u{1F3DB}\u{FE0F}', // 🏛️
    children: [
        { path: '/tenants',        label: 'Tenants' },
        { path: '/admin-users',    label: 'System Admins' },
        { path: '/tenant-admins',  label: 'Tenant Admins' },
        { path: '/subscriptions',  label: 'Subscriptions' },
        { path: '/billing/codes',  label: 'Codes' },
        { path: '/billing/orders', label: 'Orders' },
    ],
};
